import { Construction } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { EmptyState } from '@/components/feedback/EmptyState';

interface ComingSoonPageProps {
  // Full i18n key (e.g. 'medical:screens.signup'). The page title falls back to
  // the generic "Coming Soon" label when no key is supplied.
  screenKey?: string;
}

export function ComingSoonPage({ screenKey }: ComingSoonPageProps) {
  const { t } = useTranslation(['medical', 'common']);
  const title = screenKey ? t(screenKey) : t('medical:comingSoon.title');

  return (
    <div className="coming-soon-page">
      <EmptyState
        icon={Construction}
        title={title}
        description={t('medical:comingSoon.message')}
      />
    </div>
  );
}
